module.exports = __webpack_public_path__ + "img/logo-gris.86e8818f.svg";